export class Customer{
  constructor(
    public ID:number,
    public name:string,
    private father_last_name:string,
    private mother_last_name:string,
    private address: string,
    private email:string,
    private phone:string,
    private ocupation:string,
    private marital_status:string
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/customer.model.ts